// extracted by mini-css-extract-plugin
export default {"listWrapper":"tPItJ6Vz","title":"c5eR3HyK","card":"KjBX6OXy","cardTitle":"y0KbrN4_","cardSubtitle":"F3B_taPi","cardDate":"k947_pAS"};